import React from 'react';

interface WarningIconProps {
	customWidth?: string;
	customHeight?: string;
	className?: string;
	title?: string;
	cy?: string;
	handleHover?: (...args: unknown[]) => void;
	danger?: boolean;
}

export const WarningIcon = ({customWidth, customHeight, className, title, cy, handleHover, danger}: WarningIconProps) => (
	<span className={className ? className + '-title' : ''} title={title} data-cy={cy}>
		<svg
			className={className ? className : ''}
			onMouseEnter={handleHover}
			onMouseLeave={handleHover}
			xmlns="http://www.w3.org/2000/svg"
			width={customWidth ? customWidth : '16'}
			height={customHeight ? customHeight : '16'}
			viewBox="0 0 16 16"
		>
			<path
				fill={danger ? '#e01212' /*red*/ : '#e0c82f' /*yellow*/}
				fillRule="evenodd"
				d="M8.566.235a.8.8 0 0 0-1.131 0l-7.2 7.2a.8.8 0 0 0 0 1.13l7.2 7.2a.798.798 0 0 0 1.13 0l7.2-7.2a.8.8 0 0 0 0-1.13l-7.2-7.2z"
			></path>
			<path fill="#FFF" fillRule="nonzero" d="M8 12.2a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
			<path fill="#FFF" fillRule="nonzero" d="M7.2 9.188h1.6L9.6 4.8H6.4z" />
		</svg>
	</span>
);
